// React & Libraries
import React, { Fragment } from 'react';

// Ant Design
import {
  notification, Popconfirm, Popover, Button, Checkbox, Dropdown, Menu, Tooltip
} from 'antd';
import {
  LoadingOutlined, EditOutlined, AimOutlined, WhatsAppOutlined, CopyOutlined
} from '@ant-design/icons';

// UI Libraries
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import H3FormInput from '@Uilib/h3FormInput';

// Constants & Helpers
import { toISTDate } from '@Apis/constants';
import Helpers from '@Apis/helpers';

// Common Components
import SelectCustomStatus from '@Components/Common/SelectCustomStatus';

// Images & Icons
import ucIcon from '@Images/icons/unicommerce-icon.png';
import ShopifyIcon from '@Images/admin/integrations/shopify-icon.png';

// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faPrint } from '@fortawesome/free-solid-svg-icons';
import Crown from '@Images/crown2.png';

import { menuHelper, addAlpha } from '../helper';

function ViewSOLeftSectionHeader({
  props, state, updateState
}) {

  const {
    user, getSOById, isQuickView, selectedSO, updateSOStatusLoading, history, updateSOStatus, deleteSOLoading, deleteSO, syncShopifySO, syncShopifySOLoading, cancelShopifyOrder, cancelShopifyOrderLoading
  } = props;

  const {
    currentUpdate, cancellationReason, notifyCustomer, currentTenantId, currentOrderId, salesOrderType, documentUINames, isEstimate
  } = state;

  const menu = menuHelper({ props, state, updateState });

  return (
    <div className="view-document__title">
      <div className="view-document__title-number-wrapper">
        <H3Text text={selectedSO?.sales_order_number} className="view-invoice__title-number" />
      </div>

      {!isQuickView && (
        <div className="view-document__title-actions">
          {selectedSO?.unicommerce_so_code && (
            <div className="action-buttons">
              <Popconfirm
                placement="topRight"
                title={`Order last synced from unicommerce on ${selectedSO?.unicommerce_last_sync && toISTDate(selectedSO?.unicommerce_last_sync).format('DD/MM/YYYY hh:mm A')}`}
                okButtonProps={{
                  hidden: true,
                }}
                cancelButtonProps={{
                  hidden: true,
                }}
              >
                <H3Text
                  text={(
                    <div className="unicommerce-icon-so">
                      <img alt="unicommerce" src={ucIcon} />
                    </div>
                  )}
                  className="action-button action-button-big"
                />
              </Popconfirm>
            </div>
          )}

          <div className="action-buttons">
            {!selectedSO?.unicommerce_so_code && Helpers.getPermission(isEstimate ? Helpers.permissionEntities.SALES_ESTIMATE : (selectedSO?.order_type === 'ANNUAL_MAINTENANCE_CONTRACT' ? Helpers.permissionEntities.ANNUAL_MAINTENANCE_CONTRACT : Helpers.permissionEntities.SALES_ORDER), Helpers.permissionTypes.UPDATE, user) && !selectedSO?.shopify_order_id && (
              <H3Text
                text={(
                  <div onClick={() => {
                    if (selectedSO?.invoices?.length > 0 || selectedSO?.sales_orders?.length > 0 || selectedSO?.so_linked_packing_slips?.length > 0) {
                      notification.error({
                        message: `Sorry, you are not allowed to edit a ${documentUINames.uiName} for which ${isEstimate ? documentUINames.salesOrderUIName : selectedSO?.so_linked_packing_slips?.length > 0 ? 'Packing Slip' : (documentUINames.uiName === 'AMC Sales Order' ? 'Consumption Order' : 'Invoice')} has been created.`,
                        placement: 'top',
                        duration: 4,
                      });
                    } else {
                      if (window.location.href.includes('/estimate')) {
                        history.push(`/sales/estimate/update/${selectedSO?.order_id}`);
                      } else {
                        selectedSO?.order_type === 'ANNUAL_MAINTENANCE_CONTRACT' ?
                          history.push(`/sales/amc-sales-orders/update/${selectedSO?.order_id}`) :
                          history.push(`/sales/sales-orders/update/${selectedSO?.order_id}`);
                      }
                    }
                  }}
                  >
                    <EditOutlined />
                  </div>
                )}
                className="action-button"
              />
            )}

            {user?.tenant_info?.integration_tenant_whatsapp_id && Helpers.getPermission(isEstimate ? Helpers.permissionEntities.SALES_ESTIMATE : Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.UPDATE, user) && (selectedSO?.custom_status_info?.type !== 'DRAFT') && (
              <H3Text
                text={(
                  <div onClick={() => updateState({ showWhatsappDrawer: true })}>
                    <WhatsAppOutlined />
                  </div>
                )}
                className="action-button"
              />
            )}

            <Dropdown overlay={menu} trigger={['click']}>
              <div
                style={{
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '40px',
                }}
                className="action-button"
              >
                <FontAwesomeIcon icon={faPrint} style={{ fontSize: '16px' }} />
              </div>
            </Dropdown>
            {Helpers.getPermission(isEstimate ? Helpers.permissionEntities.SALES_ESTIMATE : Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.CREATE, user) && !selectedSO?.shopify_order_id && !selectedSO?.unicommerce_so_code && (
              <Tooltip
                placement="topLeft"
                title="Make a Copy"
              >
                <CopyOutlined
                  className="action-button"
                  style={{
                    justifyContent: 'center',
                    fontSize: '16px',
                  }}
                  onClick={() => {
                    history.push({
                      pathname: `/sales/${isEstimate ? 'estimate' : 'sales-orders'}/create`,
                      state: {
                        cloneSo: selectedSO?.order_id,
                        selectedTenantIdSo: selectedSO?.tenant_id,
                      },
                    });
                  }}
                />
              </Tooltip>
            )}
          </div>
          {!selectedSO?.unicommerce_so_code && (
            <div className="action-buttons">
              {selectedSO?.custom_status_info?.type !== 'VOID' && Helpers.getPermission(isEstimate ? Helpers.permissionEntities.SALES_ESTIMATE : Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.UPDATE, user) && !selectedSO?.shopify_cancelled_at && selectedSO?.shopify_fulfillment_status !== 'fulfilled' && (
                <Popover
                  placement="topRight"
                  title={`Are you sure you want to cancel this ${documentUINames.uiName?.toLowerCase()}?`}
                  content={(
                    <React.Fragment>
                      {' '}
                      <H3FormInput
                        name="cancellation reason"
                        type="text"
                        containerClassName="orgInputContainer create__right-input"
                        labelClassName="orgFormLabel"
                        inputClassName="orgFormInput"
                        placeholder=""
                        onChange={(event) => updateState({ cancellationReason: event.target.value })}
                        value={cancellationReason}
                        label="Cancellation reason"
                        maxlength="100"
                        required
                        showError={currentUpdate === 'VOID' && !cancellationReason}
                      />
                      <div>
                        <Checkbox
                          disabled={cancelShopifyOrderLoading}
                          checked={notifyCustomer}
                          onChange={(event) => {
                            updateState(
                              {
                                notifyCustomer: event.target.checked,
                              },
                            );
                          }}
                        />
                        <span style={{ fontWeight: '500', fontSize: '12px', marginLeft: '5px' }}>
                          Notify Customer
                        </span>
                      </div>
                      <div className="view-document__cancellation-buttons">
                        <Button
                          onClick={() => {
                            if (selectedSO?.shopify_order_id) {
                              if (cancellationReason) {
                                cancelShopifyOrder({
                                  order_id: selectedSO?.order_id,
                                  shopify_order_id: selectedSO?.shopify_order_id,
                                  shop_name: selectedSO?.shopify_shop_name,
                                  cancellation_reason: cancellationReason,
                                  notify_customer: notifyCustomer,
                                }, () => {
                                  const payload = {
                                    orgId: user?.tenant_info?.org_id,
                                    tenantId: currentTenantId,
                                    soId: currentOrderId,
                                    orderType: salesOrderType,
                                  };
                                  getSOById(payload);
                                  updateState({ currentUpdate: '', cancellationReason: '' });
                                });
                                updateState({ cancellationPop: false });
                              }
                            } else {
                              updateState({ currentUpdate: 'VOID' });
                              if (cancellationReason) {
                                updateSOStatus({
                                  status: 'VOID',
                                  order_id: selectedSO?.order_id,
                                  cancellation_reason: cancellationReason,
                                }, () => {
                                  const payload = {
                                    orgId: user?.tenant_info?.org_id,
                                    tenantId: currentTenantId,
                                    soId: currentOrderId,
                                    orderType: salesOrderType,
                                  };
                                  getSOById(payload);
                                  updateState({ currentUpdate: '', cancellationReason: '' });
                                });
                                updateState({ cancellationPop: false });
                              }
                            }
                          }}
                          type="primary"
                          size="small"
                        >
                          Submit
                        </Button>
                      </div>
                    </React.Fragment>

                  )}
                  trigger="click"
                >
                  <H3Text
                    text={(
                      <div style={{ width: '50px', textAlign: 'center' }}>
                        {((updateSOStatusLoading && currentUpdate === 'VOID') || cancelShopifyOrderLoading)
                          ? <LoadingOutlined /> : (
                            <span>Cancel</span>
                          )}
                      </div>
                    )}
                    onClick={() => {
                      if (!selectedSO?.shopify_order_id) {
                        if (selectedSO?.invoices?.length > 0 || selectedSO?.so_linked_packing_slips?.length > 0) {
                          notification.error({
                            message: `Sorry, you are not allowed to cancel a ${documentUINames.uiName?.toLowerCase()} for which ${selectedSO?.so_linked_packing_slips?.length > 0 ? 'Packing Slip' : 'Invoice'} Invoice has been created.`,
                            placement: 'top',
                            duration: 4,
                          });
                          updateState({ cancellationPop: false });
                        } else {
                          updateState({ cancellationPop: true });
                        }
                      }
                    }}
                    className="action-button action-button-big"
                  />
                </Popover>
              )}
              {Helpers.getPermission(isEstimate ? Helpers.permissionEntities.SALES_ESTIMATE : Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.DELETE, user) && !selectedSO?.shopify_order_id && (
                <Popconfirm
                  placement="topRight"
                  title={`Are you sure you want to delete the ${documentUINames.uiName?.toLowerCase()}?`}
                  onConfirm={() => {
                    if (selectedSO?.invoices?.length > 0 || selectedSO?.sales_orders?.length || selectedSO?.so_linked_packing_slips?.length > 0) {
                      notification.error({
                        message: `Sorry, you are not allowed to delete a ${documentUINames.uiName} for which ${selectedSO?.invoices?.length > 0 ? 'Invoice' : (selectedSO?.so_linked_packing_slips?.length > 0 ? 'Packing Slip' : documentUINames.salesOrderUIName)} has been created.`,
                        placement: 'top',
                        duration: 4,
                      });
                    } else {
                      deleteSO({
                        tenant_id: selectedSO?.tenant_id,
                        order_id: currentOrderId,
                      }, () => {
                        if (isEstimate) {
                          history.push('/sales/estimate');
                        } else {
                          history.push('/sales/sales-orders');
                        }
                      });
                    }
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  <H3Text
                    text={(
                      <div>
                        {deleteSOLoading ? <LoadingOutlined /> : (
                          <span>Delete</span>
                        )}
                      </div>
                    )}
                    className="action-button action-button-big"
                  />
                </Popconfirm>
              )}
              {['CONFIRMED'].includes(selectedSO?.custom_status_info?.type) && selectedSO?.shopify_order_id && selectedSO?.order_type === 'SALES_ORDER' && (
                <H3Text
                  className="action-button action-button-big"
                  onClick={() => {
                    syncShopifySO(
                      {
                        shopify_order_id: selectedSO?.shopify_order_id,
                        shop_name: selectedSO?.shopify_shop_name,
                      },
                      () => {
                        const payload = {
                          orgId: user?.tenant_info?.org_id,
                          tenantId: currentTenantId,
                          soId: currentOrderId,
                          orderType: salesOrderType,
                        };
                        getSOById(payload);
                      },
                    );
                  }}
                  text={(
                    <React.Fragment>
                      {!syncShopifySOLoading ? (
                        <React.Fragment>
                          <H3Image src={ShopifyIcon} className="action-menu-shopify-icon" />
                          <H3Text text="Sync" className="action-menu-button" />
                        </React.Fragment>
                      )
                        : <LoadingOutlined />}
                    </React.Fragment>
                  )}
                />
              )}
              {!['VOID'].includes(selectedSO?.custom_status_info?.type) && (
                (['CONFIRMED'].includes(selectedSO?.custom_status_info?.type) && Helpers.getPermission(Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.CREATE, user) && isEstimate && selectedSO?.order_type !== 'ANNUAL_MAINTENANCE_CONTRACT') ||
                (['CONFIRMED'].includes(selectedSO?.custom_status_info?.type) && !isEstimate && Helpers.getPermission(Helpers.permissionEntities.PACKING_SLIP, Helpers.permissionTypes.CREATE, user) && selectedSO?.order_type !== 'ANNUAL_MAINTENANCE_CONTRACT') ||
                (['CONFIRMED'].includes(selectedSO?.custom_status_info?.type) && Helpers.getPermission(Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.CREATE, user) && !selectedSO?.shopify_order_id && selectedSO?.order_type !== 'ANNUAL_MAINTENANCE_CONTRACT') ||
                (['CONFIRMED'].includes(selectedSO?.custom_status_info?.type) && Helpers.getPermission(isEstimate ? Helpers.permissionEntities.SALES_ESTIMATE : Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.UPDATE, user) && selectedSO?.shopify_order_id && window.screen.width > 425 && (selectedSO?.shopify_fulfillment_status !== 'fulfilled') && !isEstimate) ||
                (['CONFIRMED'].includes(selectedSO?.custom_status_info?.type) && Helpers.getPermission(Helpers.permissionEntities.MO, Helpers.permissionTypes.CREATE, user) && !isEstimate && window.screen.width > 425) ||
                (['CONFIRMED'].includes(selectedSO?.custom_status_info?.type) && Helpers.getPermission(Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.CREATE, user) && !isEstimate && window.screen.width > 425) ||
                (['CONFIRMED'].includes(selectedSO?.custom_status_info?.type) && Helpers.getPermission(Helpers.permissionEntities.DELIVERY_CHALLAN, Helpers.permissionTypes.CREATE, user) && !isEstimate) ||
                (['CONFIRMED'].includes(selectedSO?.custom_status_info?.type) && Helpers.getPermission(Helpers.permissionEntities.CONSUMPTION_ORDER, Helpers.permissionTypes.CREATE, user) && selectedSO?.order_type === 'ANNUAL_MAINTENANCE_CONTRACT') ||
                (['CONFIRMED'].includes(selectedSO?.custom_status_info?.type) && selectedSO?.shopify_so_object && !isEstimate && selectedSO?.order_type !== 'ANNUAL_MAINTENANCE_CONTRACT') ||
                (!['VOID'].includes(selectedSO?.custom_status_info?.type) && !isEstimate && selectedSO?.order_type !== 'ANNUAL_MAINTENANCE_CONTRACT')
              ) &&
                (
                  <Dropdown
                    overlay={(
                      <div style={{ width: '205px' }}>
                        <Menu>
                          {['CONFIRMED'].includes(selectedSO?.custom_status_info?.type) && Helpers.getPermission(Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.CREATE, user) && isEstimate && selectedSO?.order_type !== 'ANNUAL_MAINTENANCE_CONTRACT' && ( //hide in case of AMC
                            <Menu.Item>
                              <H3Text
                                text={(
                                  <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>
                                      {/* + Sales Order */}
                                      {`+ ${documentUINames.salesOrderUIName}`}
                                    </div>
                                    {!user?.tenant_info?.sales_config?.sub_modules?.sales_order?.is_active && (
                                      <Popconfirm
                                        placement="topRight"
                                        title="This feature is not accessible within your current plan to use this feature contact us."
                                        onConfirm={() => window.Intercom('showNewMessage')}
                                        okText="Contact Us"
                                        cancelText="Cancel"
                                      >
                                        <img className="barcode-restrict" style={{ marginLeft: '4px' }} src={Crown} alt="premium" />
                                      </Popconfirm>
                                    )}
                                  </div>
                                )}
                                className="hide__in-mobile"
                                onClick={() => updateState({ showNewSalesForm: true })}
                              />
                            </Menu.Item>
                          )}
                          {['CONFIRMED'].includes(selectedSO?.custom_status_info?.type) && !isEstimate && Helpers.getPermission(Helpers.permissionEntities.PACKING_SLIP, Helpers.permissionTypes.CREATE, user) && selectedSO?.order_type !== 'ANNUAL_MAINTENANCE_CONTRACT' && ( //hide in case of AMC
                            <Menu.Item>
                              <H3Text
                                text={(
                                  <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>
                                      + Packing Slip
                                    </div>
                                    {!user?.tenant_info?.sales_config?.sub_modules?.packing_slip?.is_active && (
                                      <Popconfirm
                                        placement="topRight"
                                        title="This feature is not accessible within your current plan to use this feature contact us."
                                        onConfirm={() => window.Intercom('showNewMessage')}
                                        okText="Contact Us"
                                        cancelText="Cancel"
                                      >
                                        <img className="barcode-restrict" style={{ marginLeft: '4px' }} src={Crown} alt="premium" />
                                      </Popconfirm>
                                    )}
                                  </div>
                                )}
                                className="hide__in-mobile"
                                onClick={() => updateState({ showNewPackingSlipForm: true })}
                              />
                            </Menu.Item>
                          )}
                          {['CONFIRMED'].includes(selectedSO?.custom_status_info?.type) && Helpers.getPermission(Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.CREATE, user) && !selectedSO?.shopify_order_id && selectedSO?.order_type !== 'ANNUAL_MAINTENANCE_CONTRACT' && ( //hide in case of AMC
                            <Menu.Item>
                              <H3Text
                                text={(
                                  <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>
                                      + Invoice
                                    </div>
                                    {!user?.tenant_info?.sales_config?.sub_modules?.invoice?.is_active && (
                                      <Popconfirm
                                        placement="topRight"
                                        title="This feature is not accessible within your current plan to use this feature contact us."
                                        onConfirm={() => window.Intercom('showNewMessage')}
                                        okText="Contact Us"
                                        cancelText="Cancel"
                                      >
                                        <img className="barcode-restrict" style={{ marginLeft: '4px' }} src={Crown} alt="premium" />
                                      </Popconfirm>
                                    )}
                                  </div>
                                )}
                                className="hide__in-mobile"
                                onClick={() => updateState({ showNewInvoiceForm: true })}
                              />
                            </Menu.Item>
                          )}
                          {['CONFIRMED'].includes(selectedSO?.custom_status_info?.type) && Helpers.getPermission(isEstimate ? Helpers.permissionEntities.SALES_ESTIMATE : Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.UPDATE, user) && selectedSO?.shopify_order_id && window.screen.width > 425 && (selectedSO?.shopify_fulfillment_status !== 'fulfilled') && !isEstimate && (
                            <Menu.Item onClick={() => updateState({ addShopifyADHOC: true })}>
                              <H3Text
                                text="+ Add New Item"
                                className="hide__in-mobile"
                              />
                            </Menu.Item>
                          )}
                          {['CONFIRMED'].includes(selectedSO?.custom_status_info?.type) && Helpers.getPermission(Helpers.permissionEntities.MO, Helpers.permissionTypes.CREATE, user) && !isEstimate && window.screen.width > 425 && (
                            <Menu.Item
                              onClick={() => {
                                if (!selectedSO?.mrp_id) {
                                  updateState({ showConvertToMo: true });
                                }
                              }}
                              disabled={!!selectedSO?.mrp_id} // Disable the menu item if selectedSO?.mrp_id exists
                            >
                              {!selectedSO?.mrp_id ? (
                                <H3Text
                                  text={(
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                      <div>
                                        + Manufacturing Order
                                      </div>
                                      {!user?.tenant_info?.production_config?.sub_modules?.manufacturing_order?.is_active && (
                                        <Popconfirm
                                          placement="topRight"
                                          title="This feature is not accessible within your current plan. To use this feature, contact us."
                                          onConfirm={() => window.Intercom('showNewMessage')}
                                          okText="Contact Us"
                                          cancelText="Cancel"
                                        >
                                          <img className="barcode-restrict" style={{ marginLeft: '4px' }} src={Crown} alt="premium" />
                                        </Popconfirm>
                                      )}
                                    </div>
                                  )}
                                  className="hide__in-mobile"
                                />
                              ) : (
                                <Tooltip
                                  placement="top"
                                  title={`This ${documentUINames.salesOrderUIName.toLowerCase()} is linked with MRP so you can't create Manufacturing Order for this ${documentUINames.salesOrderUIName.toLowerCase()}`}
                                >
                                  <div style={{ display: 'flex', alignItems: 'center', color: '#ccc' }}>
                                    {' '}
                                    {/* Adjust styling as needed */}
                                    + Manufacturing Order
                                    {!user?.tenant_info?.production_config?.sub_modules?.manufacturing_order?.is_active && (
                                      <img className="barcode-restrict" style={{ marginLeft: '4px', filter: 'grayscale(100%)' }} src={Crown} alt="premium" />
                                    )}
                                  </div>
                                </Tooltip>
                              )}
                            </Menu.Item>
                          )}
                          {['CONFIRMED'].includes(selectedSO?.custom_status_info?.type) && Helpers.getPermission(Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.CREATE, user) && !isEstimate && window.screen.width > 425 && (
                            <Menu.Item onClick={() => updateState({ showConvertToPr: true })}>
                              <H3Text
                                text={(
                                  <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>
                                      + Material Request
                                    </div>
                                    {!user?.tenant_info?.purchase_config?.sub_modules?.purchase_request?.is_active && (
                                      <Popconfirm
                                        placement="topRight"
                                        title="This feature is not accessible within your current plan to use this feature contact us."
                                        onConfirm={() => window.Intercom('showNewMessage')}
                                        okText="Contact Us"
                                        cancelText="Cancel"
                                      >
                                        <img className="barcode-restrict" style={{ marginLeft: '4px' }} src={Crown} alt="premium" />
                                      </Popconfirm>
                                    )}
                                  </div>
                                )}
                                className="hide__in-mobile"
                              />
                            </Menu.Item>
                          )}
                          {['CONFIRMED'].includes(selectedSO?.custom_status_info?.type) && Helpers.getPermission(Helpers.permissionEntities.DELIVERY_CHALLAN, Helpers.permissionTypes.CREATE, user) && !isEstimate && (
                            <Menu.Item>
                              <H3Text
                                text={(
                                  <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>
                                      + Delivery Challan
                                    </div>
                                    {!user?.tenant_info?.inventory_config?.sub_modules?.delivery_challan?.is_active && (
                                      <Popconfirm
                                        placement="topRight"
                                        title="This feature is not accessible within your current plan to use this feature contact us."
                                        onConfirm={() => window.Intercom('showNewMessage')}
                                        okText="Contact Us"
                                        cancelText="Cancel"
                                      >
                                        <img className="barcode-restrict" style={{ marginLeft: '4px' }} src={Crown} alt="premium" />
                                      </Popconfirm>
                                    )}
                                  </div>
                                )}
                                className="hide__in-mobile"
                                onClick={() => updateState({ showDCDrawer: true })}
                              />
                            </Menu.Item>
                          )}
                          {['CONFIRMED'].includes(selectedSO?.custom_status_info?.type) && Helpers.getPermission(Helpers.permissionEntities.CONSUMPTION_ORDER, Helpers.permissionTypes.CREATE, user) && selectedSO?.order_type === 'ANNUAL_MAINTENANCE_CONTRACT' && (
                            <Menu.Item>
                              <H3Text
                                text={(
                                  <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>
                                      + Consumption Order
                                    </div>
                                    {!user?.tenant_info?.sales_config?.sub_modules?.consumption_order?.is_active && (
                                      <Popconfirm
                                        placement="topRight"
                                        title="This feature is not accessible within your current plan to use this feature contact us."
                                        onConfirm={() => window.Intercom('showNewMessage')}
                                        okText="Contact Us"
                                        cancelText="Cancel"
                                      >
                                        <img className="barcode-restrict" style={{ marginLeft: '4px' }} src={Crown} alt="premium" />
                                      </Popconfirm>
                                    )}
                                  </div>
                                )}
                                className="hide__in-mobile"
                                onClick={() => updateState({ showConsumptionDrawer: true })}
                              />
                            </Menu.Item>
                          )}
                          {['CONFIRMED'].includes(selectedSO?.custom_status_info?.type) && selectedSO?.shopify_so_object && !isEstimate && selectedSO?.order_type !== 'ANNUAL_MAINTENANCE_CONTRACT' && ( //hide in case of AMC
                            <Menu.Item>
                              <a
                                href={selectedSO?.shopify_so_object?.order_status_url}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <H3Text
                                  text={(
                                    <Fragment>
                                      <AimOutlined />
                                      <span style={{ marginLeft: '3px' }}>Track Order</span>
                                    </Fragment>
                                  )}
                                  onClick={() => updateState({ addShopifyADHOC: true })}
                                  className="hide__in-mobile"
                                />
                              </a>
                            </Menu.Item>
                          )}
                          {!['VOID'].includes(selectedSO?.custom_status_info?.type) && !isEstimate && selectedSO?.order_type !== 'ANNUAL_MAINTENANCE_CONTRACT' && ( //hide in case of AMC
                            <Menu.Item>
                              <H3Text
                                text={(
                                  <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>
                                      Reserve Stock
                                    </div>
                                  </div>
                                )}
                                className="hide__in-mobile"
                                onClick={() => updateState({ showReservationDrawer: true })}
                              />
                            </Menu.Item>
                          )}
                        </Menu>
                      </div>
                    )}
                    trigger={['click']}
                    placement="bottomLeft"
                  >
                    <div
                      style={{ width: '70px', borderRight: 'none', whiteSpace: 'nowrap' }}
                      className="action-button action-button-big"
                      onClick={(e) => e.preventDefault()}
                    >
                      More&nbsp;&nbsp;
                      <FontAwesomeIcon icon={faCaretDown} />
                    </div>
                  </Dropdown>
                )
              }
              {Helpers.getPermission(isEstimate ? Helpers.permissionEntities.SALES_ESTIMATE : Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.UPDATE, user) && selectedSO?.custom_status_info?.type !== 'VOID' && (
                <SelectCustomStatus
                  selectedCustomStatus={selectedSO?.custom_status_id}
                  hideTitle
                  tenantId={selectedSO?.tenant_id}
                  posibleStatuses={[selectedSO?.custom_status_info, ...selectedSO?.possible_status ?? []]}
                  onChange={(value) => {
                    updateSOStatus({
                      status: value?.type,
                      secondary_status: value?.status_name,
                      order_id: selectedSO?.order_id,
                      custom_status_id: value?.custom_status_id,
                    }, () => {
                      const payload = {
                        orgId: user?.tenant_info?.org_id,
                        tenantId: currentTenantId,
                        soId: currentOrderId,
                        orderType: salesOrderType,
                      };
                      getSOById(payload);
                    });
                  }}
                  disabled={['VOID', 'SENT_FOR_APPROVAL'].includes(selectedSO?.custom_status_info?.type)}
                  customStyle={{
                    color: selectedSO?.custom_status_info?.color_code,
                    backgroundColor: addAlpha(selectedSO?.custom_status_info?.color_code, 1),
                    height: '35px',
                  }}
                />
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ViewSOLeftSectionHeader;